import React, { useEffect, useState, useRef } from 'react';
import {
  Button,
  Dialog,
  Input,
  Form,
  Select,
  Checkbox,
  DatePicker,
  Message,
  Card,
  Table,
  Switch,
  NumberPicker,
  Calendar,
  List,
  TimePicker,
} from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import Swal from 'sweetalert2';
import moment from 'moment';
import ReactDragListView from 'react-drag-listview'; //拖曳功能
import axios from 'axios';
import ezconImg from '../../../../../public/ezcon.png';
const Option = Select.Option;
const { Item } = Form;

const PatrolList = (props) => {
  const patrol = client.service('patrol');
  const [patrolArr, setPatrolArr] = useState([]);
  const [patrolTimeArr, setPatrolTimeArr] = useState({});
  const [addPatrolDialog, setAddPatrolDialog] = useState(false);
  const [editPatrolDialog, setEditPatrolDialog] = useState(false);
  const [patrolTimeDialog, setPatrolTimeDialog] = useState(false);
  const [patrolTimeCountDialog, setPatrolTimeCountDialog] = useState(false);
  const [editPatrolIndex, setEditPatrolIndex] = useState(0);
  const [patrolName, setPatrolName] = useState('');
  const [count, setCount] = useState(0);
  const [patrolNum, setPatrolNum] = useState(0);
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [checkedAll, setCheckedAll] = useState(false);
  const [checked, setChecked] = useState({
    星期一: false,
    星期二: false,
    星期三: false,
    星期四: false,
    星期五: false,
    星期六: false,
    星期日: false,
  });

  //TOGGLES checK STATE BASED ON inputName
  const toggleCheck = (inputName) => {
    setChecked((prevState) => {
      const newState = { ...prevState };
      newState[inputName] = !prevState[inputName];
      return newState;
    });
  };

  //CHECKS OR UNCHECKS ALL FROM SELECT ALL CLICK
  const selectAll = (value) => {
    setCheckedAll(value);
    setChecked((prevState) => {
      const newState = { ...prevState };
      for (const inputName in newState) {
        newState[inputName] = value;
      }
      return newState;
    });
  };

  //EFFECT TO CONTROL CHECKED_ALL STATE

  useEffect(() => {
    let allChecked = true;
    for (const inputName in checked) {
      if (checked[inputName] === false) {
        allChecked = false;
      }
    }
    if (allChecked) {
      setCheckedAll(true);
    } else {
      setCheckedAll(false);
    }
  }, [checked]);

  //查詢
  function funFind(para) {
    return new Promise((resolve, reject) => {
      try {
        patrol.find({ query: para }).then((result) => {
          resolve(result && result.data ? result.data : []);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  //新增
  function funCreate(obj) {
    return new Promise((resolve, reject) => {
      try {
        patrol.create(obj).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  //更新
  function funUpdate(id, obj) {
    return new Promise((resolve, reject) => {
      try {
        patrol.patch(id, obj).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  //刪除
  function funRemove(id) {
    return new Promise((resolve, reject) => {
      try {
        patrol.remove(id).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  function ordersort(a, b) {
    return a.order < b.order ? 1 : -1;
  }
  //刷新頁面
  function serverDataUpdate() {
    funFind({}).then((result) => {
      setPatrolArr(result.sort(ordersort));
    });
  }
  // function patrolTimeUpdate() {
  //   funFind({}).then((result) => {
  //     setPatrolTimeArr(result.sort(ordersort));
  //   });
  // }

  // (patrolArr[index].patrolTime);
  useEffect(() => {
    serverDataUpdate();
  }, []);

  //拖曳Function
  const onDragEnd = async (fromIndex, toIndex) => {
    if (toIndex < 0) return; // Ignores if outside designated area

    const items = [...patrolArr];
    const item = items.splice(fromIndex, 1)[0];
    items.splice(toIndex, 0, item); //把刪除的新增到移動的位置
    for (let i = 0; i < items.length; i++) {
      items[i].order = items.length - i - 1;
      await funUpdate(items[i]._id, items[i]);
    }
    setPatrolArr(items.sort(ordersort));
    setPatrolName('');
  };

  //刪除功能
  const removeItem = async () => {
    const result = await funFind({});
    const items = result.sort(ordersort);
    for (let i = 0; i < items.length; i++) {
      items[i].order = items.length - i - 1;
      await funUpdate(items[i]._id, items[i]);
    }
    setPatrolArr(items.sort(ordersort));
  };

  return (
    <>
      <Button
        onClick={() => {
          setAddPatrolDialog(true);
          setPatrolName('');
        }}
      >
        新增巡邏點
      </Button>
      <br />
      <br />
      {/* 新增巡邏點 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addPatrolDialog}
        onOk={() => {
          funCreate({
            createdTime: new Date().toLocaleString(),
            updatedTime: new Date().toLocaleString(),
            order: patrolArr.length,
            patrolName: patrolName,
            count: count,
            patrolTime: [],
          })
            .then((res) => {
              console.log('==patrol create success:', res.data);
              Message.success('新增成功');
              serverDataUpdate();
              setPatrolName('');
              setAddPatrolDialog(false);
            })
            .catch((error) => {
              console.log('==patrol create fail:', error);
              Message.success('新增失敗');
            });
        }}
        onCancel={() => {
          setPatrolName('');
          setAddPatrolDialog(false);
        }}
        onClose={() => {
          setPatrolName('');
          setAddPatrolDialog(false);
        }}
      >
        <Form>
          <h1>新增巡邏點</h1>
          <Item label="巡邏點名稱">
            <Input
              name="patrolName"
              placeholder="請輸入項目名稱"
              onChange={(value) => {
                // console.log('onChange', value);
                setPatrolName(value);
              }}
            />
          </Item>
        </Form>
      </Dialog>
      {/* 編輯巡邏點 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editPatrolDialog}
        onOk={() => {
          let data = patrolArr[editPatrolIndex];

          data.updatedTime = new Date().toLocaleString();
          data.patrolName = patrolName;

          funUpdate(data._id, data)
            .then((res) => {
              serverDataUpdate();
              setEditPatrolDialog(false);
              console.log('==patrol update success', res);
              Message.success('更新成功');
            })
            .catch((error) => {
              console.log('==patrol update fail:', error);
              Message.success('更新失敗');
            });
        }}
        onCancel={() => {
          setPatrolName('');
          setEditPatrolDialog(false);
        }}
        onClose={() => {
          setPatrolName('');
          setEditPatrolDialog(false);
        }}
      >
        <Form>
          <h1>編輯巡邏點</h1>
          <Item label="巡邏點名稱">
            <Input
              value={patrolName}
              name="patrolName"
              placeholder="請輸入項目名稱"
              onChange={(value) => {
                // console.log('onChange', value);
                setPatrolName(value);
              }}
            />
          </Item>
        </Form>
      </Dialog>
      {/* 設定巡邏時間 */}
      <Dialog
        hasMask
        className={styles.dialogTime}
        visible={patrolTimeDialog}
        footerActions={['cancel']}
        onCancel={() => {
          setPatrolTimeDialog(false);
        }}
        onClose={() => {
          setPatrolTimeDialog(false);
        }}
      >
        <h1>設定巡邏時間</h1>

        <Button
          type="secondary"
          onClick={() => {
            setPatrolTimeCountDialog(true);
          }}
        >
          新增巡邏時間
        </Button>
        <Button
          type="normal"
          style={{ marginLeft: '15px' }}
          onClick={() => {
            setPatrolTimeArr(patrolArr[editPatrolIndex]);
          }}
        >
          重新載入
        </Button>
        <Card free>
          <Card.Content>
            <Table dataSource={patrolTimeArr.patrolTime}>
              <Table.Column
                title="起始時間"
                dataIndex="startTime"
                width={100}
              />
              <Table.Column title="起始時間" dataIndex="endTime" width={100} />
              <Table.Column
                title="應巡邏次數"
                dataIndex="patrolNum"
                width={100}
              />
              {/* <Table.Column title="建立時間" cell={(value, index, record) => {
                // console.log(value, index, record)
                
              }} width={100} /> */}
              <Table.Column
                title="功能"
                width={100}
                cell={(value, index, record) => {
                  // console.log('==op ', value, index, record);
                  return (
                    <div className={styles.btn}>
                      {/* <Button
                        type="normal"
                        onClick={() => {
                          setPatrolName(patrolArr[index].patrolName);
                          setEditPatrolIndex(index);
                          setEditPatrolDialog(true);
                        }}
                      >
                        編輯
                        </Button> */}

                      <Button
                        type="primary"
                        warning
                        onClick={() => {
                          console.log(patrolTimeArr._id);
                          // let item = patrolArr[index];
                          Swal.fire({
                            title: '確定刪除此時段?',
                            text: '刪除後將無法復原!!',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#BEBEBE',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                          }).then(async (result) => {
                            if (result.isConfirmed) {
                              Swal.fire('刪除!', '該時段已刪除', 'success');

                              let SQuery = {};
                              SQuery[`patrolTime.${index}`] = 'toDelete';
                              await patrol.patch(patrolTimeArr._id, SQuery); //1清空
                              await patrol
                                .patch(patrolTimeArr._id, {
                                  $pull: { patrolTime: { $in: ['toDelete'] } },
                                })
                                .then((res) => {
                                  serverDataUpdate();
                                  console.log(
                                    '==patrol  patrolTime delete success',
                                    res
                                  );
                                  Message.success('刪除成功');
                                })
                                .catch((error) => {
                                  console.log(
                                    '==patrol  patrolTime delete fail:',
                                    error
                                  );
                                  Message.success('刪除失敗');
                                });
                            }
                          });
                        }}
                      >
                        刪除
                      </Button>
                    </div>
                  );
                }}
              ></Table.Column>
            </Table>
          </Card.Content>
        </Card>
      </Dialog>

      {/* 巡邏時間及次數設定 */}
      <Dialog
        hasMask
        className={styles.dialogTime}
        visible={patrolTimeCountDialog}
        onOk={() => {
          // console.log(patrolTimeArr._id)

          funUpdate(patrolTimeArr._id, {
            updatedTime: new Date().toLocaleString(),
            count: patrolTimeArr.patrolTime.length + 1,
            $addToSet: {
              patrolTime: {
                $each: [
                  {
                    checked: checked,
                    startTime: startTime,
                    endTime: endTime,
                    patrolNum: patrolNum,
                  },
                ],
              },
            },
          })
            .then((res) => {
              serverDataUpdate();
              setChecked({
                星期一: false,
                星期二: false,
                星期三: false,
                星期四: false,
                星期五: false,
                星期六: false,
                星期日: false,
              });
              setPatrolNum(0);
              setPatrolTimeCountDialog(false);
              console.log('==patrol update success', res);
              Message.success('設定成功');
            })
            .catch((error) => {
              console.log('==patrol update fail:', error);
              Message.success('設定失敗');
            });
        }}
        onCancel={() => {
          setChecked({
            星期一: false,
            星期二: false,
            星期三: false,
            星期四: false,
            星期五: false,
            星期六: false,
            星期日: false,
          });
          setPatrolNum(0);
          setPatrolTimeCountDialog(false);
        }}
        onClose={() => {
          setChecked({
            星期一: false,
            星期二: false,
            星期三: false,
            星期四: false,
            星期五: false,
            星期六: false,
            星期日: false,
          });
          setPatrolNum(0);
          setPatrolTimeCountDialog(false);
        }}
      >
        <Form>
          <h1>巡邏時間</h1>
          <Item label="每個星期">
            <div>
              <label>全部</label>
              <input
                type="checkbox"
                onChange={(event) => selectAll(event.target.checked)}
                checked={checkedAll}
              />
            </div>
            <div>
              <label>一</label>
              <input
                type="checkbox"
                name="星期一"
                onChange={() => toggleCheck('星期一')}
                checked={checked['星期一']}
              />
            </div>
            <div>
              <label>二</label>
              <input
                type="checkbox"
                name="星期二"
                onChange={() => toggleCheck('星期二')}
                checked={checked['星期二']}
              />
            </div>
            <div>
              <label>三</label>
              <input
                type="checkbox"
                name="星期三"
                onChange={() => toggleCheck('星期三')}
                checked={checked['星期三']}
              />
            </div>
            <div>
              <label>四</label>
              <input
                type="checkbox"
                name="星期四"
                onChange={() => toggleCheck('星期四')}
                checked={checked['星期四']}
              />
            </div>
            <div>
              <label>五</label>
              <input
                type="checkbox"
                name="星期五"
                onChange={() => toggleCheck('星期五')}
                checked={checked['星期五']}
              />
            </div>
            <div>
              <label>六</label>
              <input
                type="checkbox"
                name="星期六"
                onChange={() => toggleCheck('星期六')}
                checked={checked['星期六']}
              />
            </div>
            <div>
              <label>日</label>
              <input
                type="checkbox"
                name="星期日"
                onChange={() => toggleCheck('星期日')}
                checked={checked['星期日']}
              />
            </div>
          </Item>
          <Item label="開始時間">
            <TimePicker
              format="HH:mm"
              onChange={(value) => setStartTime(moment(value).format('HH:mm'))}
            />
          </Item>
          <Item label="結束時間">
            <TimePicker
              format="HH:mm"
              onChange={(value) => setEndTime(moment(value).format('HH:mm'))}
            />
          </Item>
          <Item label="應巡邏次數">
            <NumberPicker
              value={patrolNum}
              min={0}
              onChange={(value, e) => {
                setPatrolNum(value);
              }}
            />
          </Item>
        </Form>
      </Dialog>
      <ReactDragListView onDragEnd={onDragEnd}>
        <Card free>
          <Card.Content>
            <Table dataSource={patrolArr}>
              <Table.Column
                title="建立時間"
                dataIndex="createdTime"
                width={100}
              />
              <Table.Column title="順序" dataIndex="order" width={100} />
              <Table.Column
                title="巡邏點名稱"
                dataIndex="patrolName"
                width={100}
              />
              <Table.Column title="設定組數" dataIndex="count" width={100} />
              <Table.Column
                title="更新時間"
                dataIndex="updatedTime"
                width={100}
              />
              <Table.Column
                title="操作"
                width={200}
                lock="right"
                cell={(value, index, record) => {
                  // console.log('==op ', value, index, record);
                  return (
                    <div className={styles.btn}>
                      <Button
                        type="secondary"
                        onClick={() => {
                          // console.log(patrolArr[index])
                          setPatrolTimeArr(patrolArr[index]);
                          setPatrolTimeDialog(true);
                          setEditPatrolIndex(index);
                        }}
                      >
                        設定巡邏時間
                      </Button>

                      <Button
                        type="normal"
                        onClick={() => {
                          setPatrolName(patrolArr[index].patrolName);
                          setEditPatrolIndex(index);
                          setEditPatrolDialog(true);
                        }}
                      >
                        編輯
                      </Button>

                      <Button
                        type="primary"
                        warning
                        onClick={() => {
                          let item = patrolArr[index];
                          Swal.fire({
                            title: '確定刪除此巡邏點?',
                            text: '刪除後將無法復原!!',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#BEBEBE',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire('刪除!', '巡邏點已刪除', 'success');
                              funRemove(item._id).then(() => {
                                removeItem();
                              });
                            }
                          });
                        }}
                      >
                        刪除
                      </Button>
                    </div>
                  );
                }}
              ></Table.Column>
            </Table>
          </Card.Content>
        </Card>
      </ReactDragListView>
    </>
  );
};

export default PatrolList;
